import { z } from 'zod'

export const rechargeSchema = z.object({
  amount: z
    .number({ message: 'Ingresa un importe válido' })
    .positive('El importe debe ser mayor a 0'),
  deliveryChannel: z.string().min(1, 'Selecciona un canal de entrega'),
  currencyId: z
    .number({ message: 'Selecciona una moneda' })
    .int()
    .positive('Selecciona una moneda'),
})

export type RechargeFormValues = z.infer<typeof rechargeSchema>
